import React, { useState, useEffect } from "react";
import { Box, Modal, Typography, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from "@mui/material";
import { ListTransFileRecs } from "../../util/API/batch";

function SuperAdminBatchDetailsModal({ open, onClose, batch }) {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);

  const getStatusColor = (status) => {
  const colors = {
    Open: "#e2e3e5",
    Review: "#fff3cd",
    "Approved for Processing": "#d4edda",
    Rejected: "#f8d7da",
    Completed: "#d1ecf1",
    Error: "#f5c6cb",
    Cancelled: "#d6d8db",
  };
  return colors[status] || "#f8f9fa";
};

const getStatusTextColor = (status) => {
  const colors = {
    Open: "#383d41",
    Review: "#856404",
    "Approved for Processing": "#155724",
    Rejected: "#721c24",
    Completed: "#0c5460",
    Error: "#721c24",
    Cancelled: "#495057",
  };
  return colors[status] || "#333";
};

  useEffect(() => {
    if (open && batch) {
      const loadRecords = async () => {
        setLoading(true);
        try {
          const res = await ListTransFileRecs(batch.id);
          if (res.callStatus === "1") {
            const raw = res.payload?.record || [];
            const recordsArray = Array.isArray(raw) ? raw : raw ? [raw] : [];
            const mapped = recordsArray.map(item => item.Transfilerecs).filter(Boolean);
            setRecords(mapped);
          } else {
            setRecords([]);
          }
        } catch (err) {
          console.error("Failed to load batch records:", err);
          setRecords([]);
        } finally {
          setLoading(false);
        }
      };
      loadRecords();
    }
  }, [open, batch]);

  if (!batch) return null;

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "95%",
          maxWidth: 1300,
          maxHeight: "90vh",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 2,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column"
        }}
      >
        {/* Header */}
        <Box sx={{ p: 3, backgroundColor: "#5523D2", color: "white" }}>
          <Typography variant="h6">
            Batch Details - #{batch.id}
          </Typography>
          <Typography variant="body2">
            Company: <strong>{batch.companyName}</strong>
          </Typography>
          <Typography variant="body2">
            File: {batch.fileName}
          </Typography>
          <Typography variant="body2">
            {records.length} Records &bull;  Scheduled for {batch.scheduledDateStr}
          </Typography>
        </Box>

        {/* Body */}
        <Box sx={{ flex: 1, overflow: "auto", p: 3 }}>
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 10 }}>
              <CircularProgress />
            </Box>
          ) : records.length === 0 ? (
            <Typography textAlign="center" color="textSecondary" py={8}>
              No employee records found in this batch.
            </Typography>
          ) : (
            <TableContainer component={Paper} elevation={2}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                    <TableCell><strong>First Name</strong></TableCell>
                    <TableCell><strong>Last Name</strong></TableCell>
                    <TableCell><strong>Email</strong></TableCell>
                    <TableCell><strong>Phone</strong></TableCell>
                    <TableCell align="right"><strong>Amount</strong></TableCell>
                    <TableCell><strong>Currency</strong></TableCell>
                    <TableCell><strong>Status</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {records.map((rec, i) => (
                    <TableRow key={i} hover>
                      <TableCell>{rec.firstname || "—"}</TableCell>
                      <TableCell>{rec.lastname || "—"}</TableCell>
                      <TableCell>{rec.email || "—"}</TableCell>
                      <TableCell>{rec.phoneno || "—"}</TableCell>
                      <TableCell align="right">{rec.amount || "0.00"}</TableCell>
                      <TableCell>{rec.currency || "CAD"}</TableCell>
                      <TableCell>
                      {(() => {
                        const isError = !!rec.errormessage;
                        const status = isError ? "Error" : batch.status;
                        return (
                          <>
                            <Box
                              sx={{
                                backgroundColor: getStatusColor(status),
                                color: getStatusTextColor(status),
                                padding: "4px 8px",
                                borderRadius: "12px",
                                fontSize: "0.8rem",
                                display: "inline-block"
                              }}
                            >
                              {status}
                            </Box>
                            {isError && (
                              <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                                {rec.errormessage}
                              </Typography>
                            )}
                          </>
                        );
                      })()}
                    </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>

        {/* Footer */}
        <Box sx={{ p: 3, borderTop: "1px solid #eee", textAlign: "right" }}>
          <Button variant="contained" onClick={onClose}>
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default SuperAdminBatchDetailsModal;